import React, {Component} from 'react';
import './PlanItemDialog.css';
import RmDialog from "./RmDialog";
import PropTypes from 'prop-types';
import PlannerOverviewScreen from "../Planner/PlannerOverviewScreen";
import RmField from "../../Forms/RmField";
import RmButton from "../../Common/RmButton";
import axios from 'axios';
import ErrorMessage from "../../Common/ErrorMessage";
import RmRadioField from "../../Forms/RmRadioField";
import RmDateTimeField from "../../Forms/RmDateTimeField";
import RmTimeField from "../../Forms/RmTimeField";
import SafeDateTimeParser from "../../Etc/SafeDateTimeParser";

export default class PlanItemDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            task: null,
            creatingNew: false,
            busy: false,
            anythingSaved: false,
            errorMessage: null
        };
    }

    componentWillReceiveProps(nextProps) {
        let taskId = null;

        if (nextProps.task) {
            taskId = nextProps.task.id;
        }

        if ((!this.state.task && nextProps.task) || (this.state.task && taskId !== this.state.task.id)) {
            this.refreshTaskState(nextProps.task);
        }

        setTimeout(() => {
            if (nextProps.prefillStart) {
                this.handleFieldChange("start_time", nextProps.prefillStart);
            }

            if (nextProps.prefillEnd) {
                this.handleFieldChange("end_time", nextProps.prefillEnd);
            }

            if (nextProps.prefillText) {
                this.handleFieldChange("name", nextProps.prefillText);
            }

            if (this.props.autoCreate) {
                this.handleSaveClick(false);
            }
        }, 0);
    }

    handleFieldChange(propName, value) {
        let nextTask = this.state.task;

        if (propName === "start_time" || propName === "end_time") {
            let momentVal = SafeDateTimeParser.parseToMoment(value);

            if (momentVal) {
                value = momentVal.format("HH:mm");
            } else {
                value = null;
            }
        }

        nextTask[propName] = value;

        this.setState({
            task: nextTask,
            errorMessage: null
        });
    }

    componentDidMount() {
        this.refreshTaskState(this.props.task);
    }

    refreshTaskState(taskFromProps) {
        let task = taskFromProps || {};

        this.setState({
            task: task,
            creatingNew: (!task.id),
            busy: false,
            anythingSaved: false,
            errorMessage: null
        });
    }

    handleCloseClick(closeReason) {
        if (this.state.busy) {
            return;
        }

        if (closeReason === RmDialog.CLOSE_VIA_BACKGROUND_CLICK) {
            return;
        }

        this.props.onClose(!!this.state.anythingSaved);
    }

    handleSaveClick(createAnother) {
        if (this.state.busy) {
            return;
        }

        this.setState({
            busy: true,
            errorMessage: null
        });

        let method = this.state.creatingNew ? "post" : "patch";
        let apiUrl = this.state.creatingNew ? "/tasks/new" : `/tasks/${this.state.task.id}`;

        let payload = this.state.task;
        payload.period_type = this.props.periodType;
        payload.seed_task_id = (this.props.seedTask && this.props.seedTask.id) || null;

        axios[method](apiUrl, payload)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    // Save OK
                    this.setState({
                        errorMessage: null,
                        anythingSaved: true
                    });

                    if (createAnother && this.state.creatingNew) {
                        // Save and new
                        let task = { };

                        this.setState({
                            task: task,
                            creatingNew: true,
                            errorMessage: "De taak is toegevoegd.",
                            anythingSaved: false // we're calling tween save event below so turn this flag off
                        });

                        this.props.onBackgroundTweenSave();
                    } else {
                        // Save and close (default)
                        this.props.onClose(true);
                    }
                } else {
                    // Valid response but not OK, usually validation problem
                    let errorMessage = "De taak kon niet opgeslagen worden, controleer invoer.";

                    if (data.message) {
                        errorMessage = data.message;
                    }

                    this.setState({
                        errorMessage: errorMessage
                    });
                }
            })
            .catch((err) => {
                console.error('Plan item dialog, save fail', err);

                this.setState({
                    errorMessage: "De taak kon niet opgeslagen worden, controleer invoer."
                });
            })
            .then(() => {
                this.setState({
                    busy: false
                });
            });
    }

    handleIsCompleteChange(val) {
        this.handleFieldChange("is_complete", val === "y");
    }

    handleDeleteClick() {
        this.props.onDeleteClicked();
    }

    render() {
        if (!this.props.visible || this.props.autoCreate) {
            return (null);
        }

        let periodType = this.props.periodType;

        if (periodType === null) {
            throw new Error("Must periodType prop (PlanItemDialog)");
        }

        let isCreatingNew = !!this.state.creatingNew;
        let busy = !!this.state.busy;

        let diagTitle = isCreatingNew ? "Taak toevoegen" : "Taak details";
        let diagSubtitle = PlannerOverviewScreen.NICE_TITLE_MAP[periodType];

        // You can always set name and text.

        // You can only set dates for "before" and "after" -- but is always optional!
        let canEditDate = this.props.periodType === PlannerOverviewScreen.TAB_BEFORE ||
            this.props.periodType === PlannerOverviewScreen.TAB_AFTER;

        // You can only set times for "during".
        let canEditTimes = this.props.periodType === PlannerOverviewScreen.TAB_DURING;

        // You can only use "save & next new item" button when editing, not when creating.
        let canDoSaveAndNew = !!isCreatingNew;

        // You can only set the "complete/open" status when editing an item, doesn't make sense when creating.
        // Also doesn't apply to "during" stuff in this design ... [NoDuringCompletion]
        let canEditStatus = !isCreatingNew && this.props.periodType !== PlannerOverviewScreen.TAB_DURING;

        // Delete button shortcut is allowed whenever we're editing
        let canDelete = !isCreatingNew;

        // Edit flags
        let canEdit = (this.props.task == null || this.props.task.editable);

        // Seed data
        let seedTask = null;

        if (this.state.task.seed) {
            seedTask = this.state.task.seed;
        } else if (isCreatingNew && this.props.seedTask) {
            seedTask = this.props.seedTask;
        }

        return (
            <RmDialog title={diagTitle} subtitle={diagSubtitle} onCloseRequested={this.handleCloseClick.bind(this)}
                      canClose={!busy}
            >
                <div className={"PlanItemDialog"}>
                    <div>
                        {canEdit &&
                        <RmField id={"name"} label={"Taaknaam"} iconName={"pencil"}
                                 disabled={busy || !canEdit} value={this.state.task.name}
                                 onChange={this.handleFieldChange.bind(this, "name")}
                        />
                        }

                        {canEditDate &&
                        <RmDateTimeField id={"end_date"} label={"Actiedatum (optioneel)"} iconName={"calendar"}
                                         disabled={busy} value={this.state.task.end_date}
                                         onChange={this.handleFieldChange.bind(this, "end_date")}
                        />
                        }

                        {canEditTimes &&
                        <RmTimeField id={"start_time"} label={"Starttijd"} iconName={"update"}
                                     disabled={busy} value={this.state.task.start_time} zIndex={200}
                                     onChange={this.handleFieldChange.bind(this, "start_time")}/>
                        }

                        {canEditTimes &&
                        <RmTimeField id={"end_time"} label={"Eindtijd"} iconName={"restore-clock"}
                                     disabled={busy} value={this.state.task.end_time}
                                     onChange={this.handleFieldChange.bind(this, "end_time")}/>
                        }

                        {canEditStatus &&
                        <RmRadioField id={"is_complete"} label={"Taak status"} iconName={"check-circle-outline"}
                                      onChange={this.handleIsCompleteChange.bind(this)}
                                      disabled={busy} value={this.state.task.is_complete ? "y" : "n"}
                                      options={{n: "Open", y: "Voltooid"}}
                        />
                        }

                        {seedTask &&
                        <div className={"PlanItemDialog__seeded"}>
                            <i className={"mdi mdi-information-outline"}/>
                            <span>Deze taak is toegevoegd op basis van onze tips.</span>
                        </div>
                        }

                        {seedTask &&
                        <div className={"PlanItemDialog__seed-html"}
                             dangerouslySetInnerHTML={{__html: `<h3>${seedTask.name}</h3>` + seedTask.description}}/>
                        }
                    </div>
                    <div className={"PlanItemDialog__controls" + (canDelete ? " PlanItemDialog__controls--wdelete" : "")}>
                        {this.state.errorMessage && <ErrorMessage message={this.state.errorMessage}/>}
                        <div className={"PlanItemDialog__controls-row"}>
                            <RmButton label={"Opslaan"} onClick={this.handleSaveClick.bind(this, false)}
                                      busy={busy}
                            />
                            {canDoSaveAndNew &&
                            <RmButton label={"Opslaan en nieuw"} onClick={this.handleSaveClick.bind(this, true)}
                                      busy={busy}
                            />
                            }
                            <div className={"PlanItem__filler"}/>
                            {canDelete &&
                            <a className={"PlanItem__controls-item"} onClick={this.handleDeleteClick.bind(this)}
                               title={"Taak verwijderen"}
                            >
                                <i className={"mdi mdi-delete"}/>
                            </a>
                            }
                        </div>
                    </div>
                </div>
            </RmDialog>
        );
    }
}

PlanItemDialog.propTypes = {
    task: PropTypes.object,
    periodType: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onDeleteClicked: PropTypes.func.isRequired,
    onBackgroundTweenSave: PropTypes.func.isRequired,
    prefillStart: PropTypes.any,
    prefillEnd: PropTypes.any,
    prefillText: PropTypes.string,
    seedTask: PropTypes.object,
    autoCreate: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Portal/Dialog/PlanItemDialog.js